import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { CirclePlus, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaDemandaCriada = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    return acaoLower.includes('criou proposta') 
        || acaoLower === 'demanda criada' 
        || acaoLower.includes('demanda criada por duplicação')
        || acaoLower.includes('demanda criada por duplicacao');
};

const getIconDemandaCriada = (acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: CirclePlus, color: 'var(--c2e86de)' };
};

export default function CardDemandaCriada({ item, onNavigateToFile, isExpanded, onToggleExpand }: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconDemandaCriada(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={<ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />}
        />
    );
}

export const demandaCriadaConfig = {
    tipo: 'demanda_criada',
    detectaTipo: detectaDemandaCriada,
    getIcon: getIconDemandaCriada,
    temExpansao: () => true,
    Component: CardDemandaCriada
};

